import 'reflect-metadata';
import {
  Expose,
  Type,
  plainToInstance,
  instanceToPlain,
} from 'class-transformer';

export class OrderNotification {
  @Expose({ name: 'id' })
  orderId: number;

  @Expose({ name: 'invoice_no' })
  invoiceNumber: string;

  @Expose({ name: 'name' })
  status: string;

  color: string;

  @Expose({ name: 'updated_at' })
  @Type(() => Date)
  dateUpdated: Date;

  total: string;

  constructor(
    orderId: number,
    invoiceNumber: string,
    status: string,
    color: string,
    dateUpdated: Date,
    total: string
  ) {
    this.orderId = orderId;
    this.invoiceNumber = invoiceNumber;
    this.status = status;
    this.color = color;
    this.dateUpdated = dateUpdated;
    this.total = total;
  }

  static fromJson(json: Record<string, any>): OrderNotification {
    return plainToInstance(OrderNotification, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
